export default __webpack_public_path__ + "static/media/ElectricityIsEverywhere_10.672fc57f.png";